import { applyApiMessageParams, type ApiMessageParams } from "@/domains/shared/services/api";
import { API_MESSAGE_TRANSLATIONS } from "@/domains/shared/services/apiMessageTranslations";
import type { MivoTranslationType } from "@mivo/i18n";
import { getTranslation } from "@mivo/i18n";

/** Resolve plan-adjustment banner text from `code` with legacy `message` fallback (E-04, AC-05). */
export function resolvePlanAdjustmentNoticeText(options: {
    code?: string | null;
    message?: string | null;
    params?: ApiMessageParams | null;
}): string {
    const code = options.code?.trim();
    if (code) {
        const entry = (API_MESSAGE_TRANSLATIONS as Record<string, MivoTranslationType | undefined>)[code];
        if (entry) {
            return applyApiMessageParams(getTranslation(entry), options.params);
        }
    }

    return options.message?.trim() ?? "";
}
